import searchReducers from '../Search/reducers';
import { reducer as textMeTheAppReducer, TEXT_ME_THE_APP_KEY } from '@zocdoc/components/src/TextMeTheAppForm';

export default {
    ...searchReducers,
    [TEXT_ME_THE_APP_KEY]: textMeTheAppReducer,
};
